module.exports = __webpack_public_path__ + "media/application/images/reviews/active-1ac25ee1ecea489370ae383456485fb4.png";